export * from './lib/sku-capsule-ui.module';
